import React from 'react';

import { Route, Switch } from 'react-router-dom';

import DashboardLayout from 'components/dashboard/common/DashboardLayout';

import DashboardCommonLinksPage from 'pages/dashboard/DashboardCommonLinksPage';
import DashboardCommercePage from 'pages/dashboard/DashboardCommercePage';
import DashboardAppsPage from 'pages/dashboard/DashboardAppsPage';
import DashboardSocialLinksPage from 'pages/dashboard/DashboardSocialLinksPage';
import DashboardSlidersPage from 'pages/dashboard/DashboardSlidersPage';
import DashboardCryptoLinksPage from 'pages/dashboard/DashboardCryptoLinksPage';
import DashboardLocationLinksPage from 'pages/dashboard/DashboardLocationLinksPage';
import DashboardMenuPage from 'pages/dashboard/DashboardMenuPage';

import DashboardAppearancePage from 'pages/dashboard/DashboardAppearancePage';
import DashboardSettingsPage from 'pages/dashboard/DashboardSettingsPage';
import DashboardAnalyticsPage from 'pages/dashboard/DashboardAnalyticsPage';
import DashboardBillingPage from 'pages/dashboard/DashboardBillingPage';
import BillingSubscriptionPage from 'pages/dashboard/BillingSubscriptionPage';
import BillingDetailsPage from 'pages/dashboard/BillingDetailsPage';
import DashboardCatalogPage from 'pages/dashboard/DashboardCatalogPage';
import DashboardEarnPage from 'pages/dashboard/DashboardEarnPage';
import DashboardSignupGeneratorPage from 'pages/dashboard/DashboardSignupGeneratorPage';
import DashboardMusicLinksPage from 'pages/dashboard/DashboardMusicLinksPage';
import DashboardAnonymousMessagesPage from 'pages/dashboard/DashboardAnonymousMessagesPage';

import DashboardIntegrationsPage from 'pages/dashboard/DashboardIntegrationsPage';
import ShopifyIntegrationPage from 'pages/dashboard/integrations/ShopifyIntegrationPage';
import ShopifyConnectPage from 'pages/dashboard/integrations/ShopifyConnectPage';

import DashboardSecurityPage from 'pages/dashboard/DashboardSecurityPage';

import ConnectStripePage from 'pages/dashboard/payment-systems/ConnectStripePage';

import LoginPage from 'pages/authentication/LoginPage';
import GoogleLoginPage from 'pages/authentication/LoginPage/google';
import ShopifyLoginPage from 'pages/authentication/LoginPage/shopify';
import FacebookLoginPage from 'pages/authentication/LoginPage/facebook';
import SignupPage from 'pages/authentication/SignupPage';
import EmailVerificationPage from 'pages/authentication/EmailVerificationPage';
import PasswordRecoveryPage from 'pages/authentication/PasswordRecoveryPage';
import ResetPasswordPage from 'pages/authentication/ResetPasswordPage';

import AdminSetTokensPage from 'pages/admin/AdminSetTokensPage';

import NotFoundPage from 'pages/errors/NotFoundPage';


export default (
  <Switch>
    {/* ---------- INDEX PAGE ---------- */}

    <Route path="/" name="dashboard-common-links" exact>
      <DashboardLayout activePage="dashboard-links">
        <DashboardCommonLinksPage />
      </DashboardLayout>
    </Route>

    {/* ---------- MAIN DASHBOARD PAGES ---------- */}

    <Route path="/appearance" name="dashboard-appearance">
      <DashboardLayout activePage="dashboard-appearance">
        <DashboardAppearancePage />
      </DashboardLayout>
    </Route>

    <Route path="/settings" name="dashboard-settings">
      <DashboardLayout activePage="dashboard-settings">
        <DashboardSettingsPage />
      </DashboardLayout>
    </Route>

    <Route path="/analytics" name="dashboard-analytics">
      <DashboardLayout activePage="dashboard-analytics">
        <DashboardAnalyticsPage />
      </DashboardLayout>
    </Route>

    <Route path="/store" name="dashboard-store">
      <DashboardLayout activePage="dashboard-store">
        <DashboardCatalogPage />
      </DashboardLayout>
    </Route>

    <Route path="/earn" name="dashboard-earn">
      <DashboardLayout activePage="dashboard-earn">
        <DashboardEarnPage />
      </DashboardLayout>
    </Route>

    <Route path="/email-signup" name="dashboard-email-signup">
      <DashboardLayout activePage="dashboard-email-signup">
        <DashboardSignupGeneratorPage />
      </DashboardLayout>
    </Route>

    <Route path="/messages" name="dashboard-anonymous-messages">
      <DashboardLayout activePage="dashboard-anonymous-messages">
        <DashboardAnonymousMessagesPage />
      </DashboardLayout>
    </Route>


    {/* ---------- LINKS PAGES ---------- */}

    <Route path="/links/common" name="dashboard-common-links">
      <DashboardLayout activePage="dashboard-links">
        <DashboardCommonLinksPage />
      </DashboardLayout>
    </Route>

    <Route path="/links/social" name="dashboard-social-links">
      <DashboardLayout activePage="dashboard-links">
        <DashboardSocialLinksPage />
      </DashboardLayout>
    </Route>

    <Route path="/links/commerce" name="dashboard-commerce-links">
      <DashboardLayout activePage="dashboard-links">
        <DashboardCommercePage />
      </DashboardLayout>
    </Route>

    <Route path="/links/apps" name="dashboard-apps-links">
      <DashboardLayout activePage="dashboard-links">
        <DashboardAppsPage />
      </DashboardLayout>
    </Route>

    <Route path="/links/music" name="dashboard-music-links">
      <DashboardLayout activePage="dashboard-links">
        <DashboardMusicLinksPage />
      </DashboardLayout>
    </Route>

    <Route path="/links/sliders" name="dashboard-sliders-links">
      <DashboardLayout activePage="dashboard-links">
        <DashboardSlidersPage />
      </DashboardLayout>
    </Route>

    <Route path="/links/crypto" name="dashboard-crypto-links">
      <DashboardLayout activePage="dashboard-links">
        <DashboardCryptoLinksPage />
      </DashboardLayout>
    </Route>

    <Route path="/links/location" name="dashboard-location-links">
      <DashboardLayout activePage="dashboard-links">
        <DashboardLocationLinksPage />
      </DashboardLayout>
    </Route>

    <Route path="/links/menu" name="dashboard-menu-links">
      <DashboardLayout activePage="dashboard-links">
        <DashboardMenuPage/>
      </DashboardLayout>
    </Route>



    {/* ---------- BILLING PAGES ---------- */}
    <Route path="/billing/subscription" name="dashboard-billing-subscription">
      <DashboardLayout activePage="dashboard-billing-subscription">
        <BillingSubscriptionPage />
      </DashboardLayout>
    </Route>

    <Route path="/billing/details" name="dashboard-billing-details">
      <DashboardLayout activePage="dashboard-billing-details">
        <BillingDetailsPage />
      </DashboardLayout>
    </Route>

    <Route path="/billing" name="dashboard-billing">
      <DashboardLayout activePage="dashboard-billing">
        <DashboardBillingPage />
      </DashboardLayout>
    </Route>


    {/* ---------- SECURITY PAGES ---------- */}

    <Route path="/security" name="dashboard-security">
      <DashboardLayout activePage="dashboard-security">
        <DashboardSecurityPage />
      </DashboardLayout>
    </Route>


    {/* ---------- INTEGRATION PAGES ---------- */}
    <Route
      path="/integrations/shopify/connect"
      name="dashboard-integrations-shopify-connect"
      component={ShopifyConnectPage}
    />

    <Route path="/integrations/shopify" name="dashboard-integrations-shopify">
      <DashboardLayout activePage="dashboard-integrations">
        <ShopifyIntegrationPage />
      </DashboardLayout>
    </Route>

    <Route path="/integrations" name="dashboard-integrations">
      <DashboardLayout activePage="dashboard-integrations">
        <DashboardIntegrationsPage />
      </DashboardLayout>
    </Route>


    {/* ---------- PAYMENT SYSTEMS PAGES ---------- */}
    <Route path="/stripe-connect" name="dashboard-stripe-connect" component={ConnectStripePage} />


    {/* ---------- AUTHENTICATION PAGES ---------- */}
    <Route path="/login/google" name="google" component={GoogleLoginPage} />
    <Route path="/login/facebook" name="facebook" component={FacebookLoginPage} />
    <Route path="/login/shopify" name="google" component={ShopifyLoginPage} />
    <Route path="/login" name="login" component={LoginPage} />
    <Route path="/signup/email-verification/:key" name="email-verification" component={EmailVerificationPage} />
    <Route path="/signup" name="signup" component={SignupPage} />
    <Route path="/password-recovery/reset/:key" name="reset-password" component={ResetPasswordPage} />
    <Route path="/password-recovery" name="password-recovery" component={PasswordRecoveryPage} />


    {/* ---------- ADMIN PAGES ---------- */}
    <Route path="/set-tokens/:accessToken/:refreshToken" name="set-tokens" component={AdminSetTokensPage} />


    {/* ---------- 404 NOT FOUND PAGE ---------- */}
    <Route name="not-found" path="*" component={NotFoundPage} />
  </Switch>
);
